export default "__VITE_ASSET__PJdpGZU9__"